import React from "react";
import { useState } from "react";
import {
  Input,
  Row,
  Col,
  Select,
  Drawer,
  DatePicker,
  Divider,
  InputNumber,
  Spin,
  message,
} from "antd";
import PhoneInput, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import moment from "moment";
import "./RightDetailWidget.css";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import { isEmpty, ValidateEmail } from "utils/GlobalFunctions";
import { useEffect } from "react";
import { MaskedInput } from "antd-mask-input";
import StepItemWidget from "./StepItemWidget";
import { showEncryptModal } from "./EncryptModal/showEncryptModal";
import { useSelector } from "react-redux";
import UiForm from "components/UiForm/UiForm";
import { apiGetUiForms } from "services/dashboardService";

const { Option } = Select;

const isNumber = (str) => {
  return /^\d+$/.test(str);
};

function CampRightDetailWidget(props) {
  const {
    visible,
    setVisible,
    userData,
    setUserData,
    updateData,
    telePhone,
    setTelephone,
    homePhone,
    setHomephone,
    cellPhone,
    setCellphone,
    contactPhone,
    setContactPhone,
    tripList,
  } = props;
  const userDataStore = useSelector((x) => x.userDataStore);
  const appDataStore = useSelector((x) => x.appDataStore);
  const [errorField, setErrorField] = useState([]);
  const dateFormat = "YYYY-MM-DD";
  const [uiList, setUiList] = useState([]);
  const [mainFormList, setMainFormList] = useState([]);
  const [loadingUiSchema, setLoadingUiSchema] = useState(false);

  useEffect(() => {
    setErrorField([]);
    if (visible && appDataStore?.curRegistration?.ID) {
      setLoadingUiSchema(true);
      const params = new URLSearchParams();
      params.append("token", userDataStore.token);
      params.append("registration_id", appDataStore.curRegistration.ID);
      apiGetUiForms(params)
        .then((res) => {
          setUiList(res.ui_list || []);
          setLoadingUiSchema(false);
        })
        .catch(() => {
          setUiList([]);
          setLoadingUiSchema(false);
        });
    }
  }, [visible, appDataStore?.curRegistration?.ID]);

  useEffect(() => {
    if (uiList.length > 0) {
      let tmpMList = [...uiList.filter((x) => x.group_type == "1")];
      setMainFormList(tmpMList);
    }
  }, [uiList]);

  const onClose = () => {
    setErrorField([]);
    setVisible(false);
  };
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  // Group fields by group_type
  const groupedFields = {};
  uiList.forEach(field => {
    if (!groupedFields[field.group_type]) groupedFields[field.group_type] = [];
    groupedFields[field.group_type].push(field);
  });

  // Optionally, map group_type to section titles
  const sectionTitles = {
    1: "Participant Info",
    2: "Parent/Guardian",
    3: "Emergency Contact",
    // ...add more as needed
  };

  const validateOneFields = () => {
    let errorList = [];
    // Dynamically validate required fields from all groups
    uiList.forEach((element) => {
      if (element.is_required === "true") {
        const value = userData[element.reg_column_name];
        if (!value || value === "" || value === " ") {
          errorList.push(element.reg_column_name);
        }
      }
    });
    setErrorField([...errorList]);
    console.log("Validation errors:", errorList);
    return errorList.length === 0;
  };

  const onUpdateData = () => {
    let valid = validateOneFields();
    console.log("Validation result:", valid);
    if (!valid) return;
    console.log("Calling updateData...");
    updateData();
    onClose();
  };

  const showHealthForm = async (u_data) => {
    var resInfo = await showEncryptModal({
      title: "Decrypting health form for user[" + userDataStore.user.EMAIL + "]",
      user_data: u_data,
    });
    if (resInfo == null) return;
  }
  
  const onCheck = (id) => {
    if (userData.camper_sel_trip && userData.camper_sel_trip.includes(id)) {
      let tmpCheckedFees = [...userData.camper_sel_trip.split(",")];
      tmpCheckedFees = tmpCheckedFees.filter((x) => x != "" && x != id);
      let newIDs = tmpCheckedFees.join(",");
      if (newIDs != "") {
        newIDs = newIDs + ",";
      }
      setUserData({ ...userData, camper_sel_trip: newIDs });
    } else {
      setUserData({
        ...userData,
        camper_sel_trip: (userData.camper_sel_trip || "") + id + ",",
      });
    }
  };
  return (
    <>
      <Drawer
        title=""
        placement="right"
        onClose={onClose}
        open={visible}
        className="camper right-detail-drawer"
      >
        {loadingUiSchema ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 300 }}>
            <Spin spinning={true} size="large" />
          </div>
        ) : (
          <>
            {Object.entries(groupedFields).map(([groupType, fields]) => (
              <div
                className="block"
                key={groupType}
                style={{
                  marginBottom: 32,
                  padding: 16,
                  background: "#fafbfc",
                  borderRadius: 8,
                  boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
                }}
              >
                <div>
                  <Row justify="space-between">
                    <Col>
                      <span className="title">{sectionTitles[groupType] || `Section ${groupType}`}</span>
                    </Col>
                  </Row>
                  <Divider style={{ borderTop: "1px solid rgb(151, 196, 217, 71%)" }} />
                </div>
                <div style={{ marginTop: 10 }}>
                  <Row gutter={[16, 16]}>
                    {fields.map((element, fIndex) => (
                      <UiForm
                        key={fIndex}
                        index={fIndex}
                        element={element}
                        value={userData[element.reg_column_name]}
                        errorField={errorField}
                        setErrorField={setErrorField}
                        userData={userData}
                        setUserData={setUserData}
                        data={userData}
                        isEditParticipant={true}
                      />
                    ))}
                  </Row>
                  {groupType == 1 && (
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: 20 }}>
                      <CommonButton
                        onClick={() => showHealthForm(userData)}
                        type="primary"
                        style={{ marginRight: 16 }}
                      >
                        Show Health Form
                      </CommonButton>
                      <label style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                        <input
                          type="checkbox"
                          checked={userData.immun_verified === "1"}
                          onChange={e =>
                            setUserData({
                              ...userData,
                              immun_verified: e.target.checked ? "1" : "0",
                            })
                          }
                          style={{ marginRight: 8 }}
                        />
                        Immunization Verified
                      </label>
                    </div>
                  )}
                </div>
              </div>
            ))}
            {/* Extra Programs Section - Updated */}
            {tripList && tripList.length > 0 && (
              <div style={{ marginTop: 20 }}>
                <span className="title">Extra Programs</span>
                <Divider />
                <div>
                  <div style={{ fontSize: 16, color: "var(--blueColor)", marginTop: 10 }}>
                    {(userData.camper_first_name || userData.first_name || "Participant") + " " + (userData.camper_last_name || userData.last_name || "1")} Extra Programs
                  </div>
                  <div className="block" style={{ marginTop: 10, padding: 10 }}>
                    {tripList.map((x, index) => (
                      <StepItemWidget
                        itemInfo={x}
                        onCheck={onCheck}
                        key={index}
                        camperIndex={0}
                        isLast={index === tripList.length - 1}
                        userData={userData}
                      />
                    ))}
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '16px', background: '#fff', borderTop: '1px solid #f0f0f0', display: 'flex', justifyContent: 'center' }}>
          <CommonButton
            onClick={onUpdateData}
            type="primary"
            style={{ minWidth: '160px', textAlign: 'center' }}
          >
            Update
          </CommonButton>
        </div>
      </Drawer>
    </>
  );
}

export default CampRightDetailWidget;